import { render, staticRenderFns } from "./PositionsViewSelector.vue?vue&type=template&id=6682cc4c&scoped=true"
import script from "./PositionsViewSelector.vue?vue&type=script&lang=js"
export * from "./PositionsViewSelector.vue?vue&type=script&lang=js"
import style0 from "./PositionsViewSelector.vue?vue&type=style&index=0&id=6682cc4c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../admin/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6682cc4c",
  null
  
)

export default component.exports